import MENU_UI_ACTIONS from './MenuUiActionConstants';
import PAGE_UI_ACTIONS from './PageUiActionConstants';

const UI_ACTIONS = { ...MENU_UI_ACTIONS, ...PAGE_UI_ACTIONS };
export default UI_ACTIONS;
